import { createContext, useContext } from "react";

/**
 * ProjectWrapper が配下（各タブ・パネル・バナー）へ配るプロジェクト画面共通の操作。
 * ProjectWrapper の外で使われた場合は既定値（プロジェクトの設定を開けない）になる。
 */
export interface ProjectShellContextValue {
  /** プロジェクトの設定（config タブ）を開けるポジションか */
  canOpenSettings: boolean;
  /** プロジェクトの設定を表示中か */
  isSettingsOpen: boolean;
  /** プロジェクトの設定を開く（Preview 表示中は Preview を閉じて開く） */
  openSettings: () => void;
  /** 表示中なら開く前のタブへ戻し、そうでなければ開く */
  toggleSettings: () => void;
}

export const ProjectShellContext = createContext<ProjectShellContextValue>({
  canOpenSettings: false,
  isSettingsOpen: false,
  openSettings: () => {},
  toggleSettings: () => {},
});

export const useProjectShell = (): ProjectShellContextValue =>
  useContext(ProjectShellContext);
